var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.5C1.45 20.5 0.979167 20.3042 0.5875 19.9125C0.195833 19.5208 0 19.05 0 18.5V4.5C0 3.95 0.195833 3.47917 0.5875 3.0875C0.979167 2.69583 1.45 2.5 2 2.5H3V1.5C3 1.21667 3.09583 0.979167 3.2875 0.7875C3.47917 0.595833 3.71667 0.5 4 0.5C4.28333 0.5 4.52083 0.595833 4.7125 0.7875C4.90417 0.979167 5 1.21667 5 1.5V2.5H13V1.5C13 1.21667 13.0958 0.979167 13.2875 0.7875C13.4792 0.595833 13.7167 0.5 14 0.5C14.2833 0.5 14.5208 0.595833 14.7125 0.7875C14.9042 0.979167 15 1.21667 15 1.5V2.5H16C16.55 2.5 17.0208 2.69583 17.4125 3.0875C17.8042 3.47917 18 3.95 18 4.5V18.5C18 19.05 17.8042 19.5208 17.4125 19.9125C17.0208 20.3042 16.55 20.5 16 20.5H2ZM2 18.5H16V8.5H2V18.5Z",
    fill: "#CC334D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCalendar);
export default __webpack_public_path__ + "static/media/event-calendar.f54822a3206a0d306cca9cf3b4592d02.svg";
export { ForwardRef as ReactComponent };